import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { checkEntityBeforeDelete } from "../../modules/config";
import ConfirmationModal from "../../ui/primitives/ConfirmationModal";

const EntityDeleteConfirmation = ({
  show,
  type,
  handleClose,
  handleConfirm,
  entityToDelete,
}) => {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkData = async () => {
      if (!entityToDelete || type === "AUTOMATION_FIELDS") {
        setResponseData([]);
        return;
      }

      setLoading(true);

      try {
        const response = await checkEntityBeforeDelete(
          entityToDelete,
          type
        );

        setResponseData(
          response?.schema_using_this_entity || []
        );
      } catch (error) {
        console.error("Failed to verify entity usage:", error);
        setResponseData([]);
      } finally {
        setLoading(false);
      }
    };

    if (show) {
      checkData();
    } else {
      setResponseData([]);
      setLoading(false);
    }
  }, [show, entityToDelete, type]);

  const handleModalClose = () => {
    setResponseData([]);
    handleClose();
  };

  const isDeleteBlocked = responseData.length > 0;

  const renderBody = () => {
    if (loading) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
          width="100%"
        >
          <CircularProgress size={28} />
          <Typography variant="body2" color="text.secondary">
            Verifying dependencies...
          </Typography>
        </Box>
      );
    }

    if (isDeleteBlocked) {
      return (
        <Box width="100%">
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2 }}
          >
            This entity cannot be deleted because it is currently
            being used in the following places:
          </Typography>

          <Alert severity="warning">
            <Box display="flex" flexDirection="column" gap={1}>
              {responseData.map((item, index) => (
                <Box
                  key={index}
                  display="flex"
                  alignItems="flex-start"
                  gap={1}
                >
                  <Typography variant="body2">
                    {item.message}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Alert>
        </Box>
      );
    }

    return (
      <Typography variant="body2">
        Are you sure you want to delete this entity? This
        action cannot be undone.
      </Typography>
    );
  };

  return (
    <ConfirmationModal
      show={show}
      width="sm"
      handleClose={handleModalClose}
      handleConfirm={handleConfirm}
      title={isDeleteBlocked ? "Cannot Delete Entity" : "Confirm Delete"}
      body={renderBody()}
      buttonLabel="Delete"
      buttonStyle="error"
      loading={loading}
      hideConfirmButton={loading || isDeleteBlocked}
    />
  );
};

export default EntityDeleteConfirmation;